














































import {Component, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import {openNewWindow} from '@/utils'
import {TaxRefund} from '@/store/modules/taxrefund/types'
import toCurrency from '@/filters/to-currency'
import {Bracket, RefundProgressBar} from '@/icons'

const taxrefund = namespace('taxrefund')

@Component({
  components: {
    Bracket,
    RefundProgressBar
  }
})
export default class BeforeSurvey extends Vue {
  @taxrefund.State('taxrefund') taxrefund?: TaxRefund
  @taxrefund.Getter('getSurveyKey') surveyKey: string
  @taxrefund.Action('postSurveyKey') postSurveyKey: () => void

  get conservativeTaxRefund(): number {
    const {refundPerYear} = this.taxrefund as TaxRefund
    const totalRefundAmount = Math.floor(refundPerYear.reduce((prev, curr) => curr.amount + prev, 0))
    return totalRefundAmount
  }

  toCurrencyValue(value, hasFilter?: boolean) {
    return toCurrency(value, hasFilter)
  }

  async handleOpen() {
    const postSurveyKeyEntity = this.postSurveyKey()
    await Promise.all([postSurveyKeyEntity])

    const targetUrl = process.env.NODE_ENV !== 'production' ? 'https://sole-app.stag-a.overtax.co.kr' : 'https://app.sole.overtax.co.kr'

    const surveyUrl = `${targetUrl}/survey/corporation/?session_key=${this.surveyKey}`
    openNewWindow(surveyUrl, '_self')
  }
}
